import store from '../../../store/main';

function onRoleAccountDeleted(event) {
  event.data.ids.forEach(id => {
    store.commit('roles/deleteRole', { type: 'account', id });
  });
}

export default onRoleAccountDeleted;
